import React, { useState, useEffect, useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from 'bootstrap';
import { useNavigate } from "react-router-dom";
import clientHttp from '../../components/ClientHttp';
import Pagination from '../../components/Pagination';
import EBankingList from './EBankingList';
import { menuPermissionHasUpdate } from '../../components/DataList';
import secureLocalStorage from "react-secure-storage";

export default function EBankingContent() {
    const currentDate = new Date();
    const [fromDate, setFromDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
    const [toDate, setToDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())); //useState(currentDate);
    const [filter, setFilter] = useState('N')
    const [filterValue, setFilterValue] = useState('')
    const [filterValueMax, setFilterValueMax] = useState('')
    const [data, setData] = useState(null);
    const [totalAmount, setTotalAmount] = useState(0)
    const [grandTotalAmount, setGrandTotalAmount] = useState(0)
    const [error, setError] = useState('');
    const [errorClass, setErrorClass] = useState('');
    const [isSearchLoading, setIsSearchLoading] = useState(false)
    const [orderStatus, setOrderStatus] = useState('N');
    const [isPaidTransactionChecked, setIsPaidTransactionChecked] = useState(true);
    const [placeholderMin, setPlaceholderMin] = useState('')
    const [placeholderMax, setPlaceholderMax] = useState('')

    let navigate = useNavigate()

    // change page
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0)
    const [pageSize, setPageSize] = useState(10);
    const onPageChange = (page) => {
        setCurrentPage(page);
        console.log('select page: ' + page)
        searchSubmit(page)
    }
    const selectPageSize = (e) => { setPageSize(e.target.value) }
    // dropdown list
    const selectFilter = (e) => { 
        setFilter(e.target.value) 
        setFilterValue('')
        setFilterValueMax('')
        if (e.target.value === 'A') { 
            setPlaceholderMin('Min')
            setPlaceholderMax('Max')
        } else if (e.target.value === 'RC') {
            setPlaceholderMin('Enter Ref Code')
        } else if (e.target.value === 'ON') {
            setPlaceholderMin('Enter Order No')
        }
    }
    const changeFilterValue = (e) => { setFilterValue(e.target.value) }
    const changeFilterValueMax = (e) => { setFilterValueMax(e.target.value) }
    const onDateChange = (newDate) => {
        console.log('select from date: ' + newDate)
        setFromDate(newDate)
        setToDate(newDate)
        //setToDate(new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()+1))
    };
    const handleOrderStatusChange = (event) => { setOrderStatus(event.target.value); };
    const handlePaidTransactionChange = (event) => {
        setIsPaidTransactionChecked(event.target.checked); // Update state based on checkbox's new checked status
    };
    // DatePicker
    const fromDateCalendar = useRef(null)
    const toDateCalendar = useRef(null)
    async function openFromDateCalendar() { fromDateCalendar.current.setFocus(true); }
    async function openToDateCalendar() { toDateCalendar.current.setFocus(true); }

    async function searchSubmit(page) {
        setCurrentPage(page);
        setIsSearchLoading(true)
        let isSuccess = false
        // clear data
        setError('')
        setErrorClass('')
        setData(null)

        // prepare parameters
        console.log('call search api with parameters:' + fromDate, toDate, filter, filterValue, filterValueMax, orderStatus, isPaidTransactionChecked, page, pageSize)
        const _fromDate = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
        const toDate2 = new Date(toDate)
        toDate2.setDate(toDate2.getDate() + 1)
        const _toDate = toDate2.getFullYear() + '-' + (toDate2.getMonth() + 1) + '-' + toDate2.getDate();
        const formData = {
            fromDate: _fromDate,
            toDate: _toDate,
            filter: filter,
            filterValue: filterValue.trim(),
            filterValueMax: filterValueMax.trim(),
            orderStatus: orderStatus,
            paidTransaction: isPaidTransactionChecked ? 'Y' : 'N',
            page: page,
            pageSize: pageSize,
        }
        console.log(formData)

        // call search api
        let token = localStorage.getItem('token')
        await clientHttp.post('onlinepayment/v1/ebanking_list', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('display ebanking list')
                setTotal(response.data.total)
                setData(response.data.data)
                setTotalAmount(response.data.totalamount)
                setGrandTotalAmount(response.data.grandtotalamount)
                //console.log(response)
                isSuccess = true
                setErrorClass('text-black')
            } else {
                console.log('get ebanking list failed: ' + response.data.message)
                setError(response.data.message)
                setErrorClass('text-danger')
            }

        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get ebanking list failed: ' + err.message)
                setError(err.message)
                setErrorClass('text-danger')
            }
        })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        setIsSearchLoading(false)
    }

    // check menu permission
    const [hasUpdatePermission, setHasUpdatePermission] = useState(false)
    useEffect(() => {
        // get cc types list
        (async () => {
            const menuperm = JSON.parse(secureLocalStorage.getItem('menuperm'));
            let hasUpdate = await menuPermissionHasUpdate(menuperm, window.location.pathname)
            console.log('check has update of pathname: ' + window.location.pathname + ', ' + hasUpdate)
            setHasUpdatePermission(hasUpdate)            
        })()
    }, [])

    return (
        <>
            <div className="page-header">
            </div>
            <div className="row">
                <div className="col-md-12">
                    {/* start form */}
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">From Date:</span>
                                            <DatePicker className="form-control" ref={fromDateCalendar} selected={fromDate} onChange={(date) => setFromDate(date)} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openFromDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>

                                            <span className="input-group-text ms-3">To Date:</span>
                                            <DatePicker className="form-control" ref={toDateCalendar} selected={toDate} onChange={(date) => setToDate(date)} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openToDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-1 col-md-1 col-sm-1">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <select className="form-select" defaultValue={pageSize} onChange={selectPageSize}>
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="500">500</option>
                                                <option value="1000">1000</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                    <div className="form-group">
                                        {isSearchLoading ?
                                            <button className="btn btn-black btn-border btn-primary" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-primary" style={{ "width": "120px" }} onClick={searchSubmit.bind(this, 1)}>
                                                <i className="bi bi-search me-2"></i> Search
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">Filter:</span>
                                            <select className="form-select" value={filter} onChange={selectFilter}>
                                                <option value="N">None</option>
                                                <option value="A">Amount</option>
                                                <option value="RC">Ref Code</option>
                                                <option value="ON">Order No</option>
                                            </select>
                                            { filter !== 'N' && <input type="text" className="form-control ms-2" placeholder={placeholderMin} value={filterValue}  onChange={changeFilterValue} /> }
                                            { filter === 'A' && <><span className="ms-2 mt-2">and</span>
                                            <input type="text" className="form-control ms-2" placeholder={placeholderMax} value={filterValueMax} onChange={changeFilterValueMax} /></>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="orderStatus" id="orderStatusNone" value="N" checked={orderStatus === 'N'} onChange={handleOrderStatusChange} /> All
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="orderStatus" id="orderStatusPaid" value="P" checked={orderStatus === 'P'} onChange={handleOrderStatusChange} /> Paid
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="orderStatus" id="orderStatusNotPaid" value="NP" checked={orderStatus === 'NP'} onChange={handleOrderStatusChange} /> Not Paid
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="orderStatus" id="orderStatusNotMatch" value="NM" checked={orderStatus === 'NM'} onChange={handleOrderStatusChange} /> Not Match
                                            </div>
                                            <div className="form-check ms-5">
                                                <input className="form-check-input" type="checkbox" id="paidTransaction" checked={isPaidTransactionChecked} onChange={handlePaidTransactionChange} /> Only Paid Transaction
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end form */}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    {data && <EBankingList data={data} totalAmount={totalAmount} grandTotalAmount={grandTotalAmount} searchSubmit={searchSubmit} currentPage={currentPage} hasUpdatePermission={hasUpdatePermission} /> }
                </div>
            </div>

            {data &&
                <Pagination total={total} pageSize={pageSize} currentPage={currentPage} onPageChange={onPageChange} />
            }
            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="errorMessageModal" tabIndex="-1" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <p className={errorClass}>{error}</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}